var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8445 16.3903L15.4991 14.0449C15.3818 13.9511 15.2411 13.8807 15.1003 13.8807H14.7251C15.3583 13.0598 15.7571 12.0278 15.7571 10.8785C15.7571 8.20472 13.5523 6 10.8785 6C8.18126 6 6 8.20472 6 10.8785C6 13.5758 8.18126 15.7571 10.8785 15.7571C12.0043 15.7571 13.0363 15.3818 13.8807 14.7251V15.1238C13.8807 15.2645 13.9276 15.4052 14.0449 15.5225L16.3669 17.8445C16.6014 18.079 16.9532 18.079 17.1643 17.8445L17.821 17.1878C18.0556 16.9767 18.0556 16.6249 17.8445 16.3903ZM10.8785 13.8807C9.21326 13.8807 7.87636 12.5438 7.87636 10.8785C7.87636 9.23671 9.21326 7.87636 10.8785 7.87636C12.5203 7.87636 13.8807 9.23671 13.8807 10.8785C13.8807 12.5438 12.5203 13.8807 10.8785 13.8807Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1565339750d22c36b99d5c9489714776.svg";
export { ForwardRef as ReactComponent };